export default "__VITE_ASSET__FWY0oof6__"